import React from 'react';
import DatosPersonales from '../padre/detalle_matricula_padre/datos_personales';
import DatosMedicos from '../padre/detalle_matricula_padre/datos_medicos';
import DesarrolloMotrizLenguaje from '../padre/detalle_matricula_padre/desarrollo_motriz_lenguaje';
import DesarrolloSocialAfectivo from '../padre/detalle_matricula_padre/desarrollo_social_afectivo';
import Antecedentes from '../padre/detalle_matricula_padre/antecedentes';
import MatriculaDatos from '../padre/detalle_matricula_padre/matricula_datos';

const DetalleMatricula = ({ matricula }) => {
  if (!matricula) {
    return <div className="p-4">No hay datos disponibles</div>;
  }

  return (
    <div className="h-[calc(100vh-12rem)] overflow-y-auto">
      <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-6 p-4">
        <DatosPersonales matricula={matricula} />
        <DatosMedicos matricula={matricula} />
        <DesarrolloMotrizLenguaje matricula={matricula} />
        <DesarrolloSocialAfectivo matricula={matricula} />
        <Antecedentes matricula={matricula} />
        <MatriculaDatos matricula={matricula} />
      </div>
    </div>
  );
};

export default DetalleMatricula;